export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/337e6e78ba943146746e2df6c168d222.jpg')`
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
        <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
          Solusi Material Beton Berkualitas<br />untuk Proyek Anda
        </h1>
        <p className="text-lg md:text-xl text-gray-200 mb-8 max-w-3xl mx-auto">
          Cobramas Production adalah produsen terpercaya batako, paving block, roster beton, dan material bangunan berkualitas tinggi di Boyolali. Kami menghadirkan produk beton pracetak dengan standar kualitas terbaik untuk mendukung kesuksesan proyek konstruksi Anda.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a 
            href="https://wa.me/6285642080427"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-orange-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-orange-700 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap inline-flex items-center gap-2"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            WhatsApp Sekarang
          </a>
          <button 
            onClick={() => {
              const element = document.getElementById('products');
              if (element) {
                const offset = 80;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - offset;
                window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
              }
            }}
            className="bg-white text-gray-900 px-8 py-4 rounded-lg text-base font-semibold hover:bg-gray-100 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap"
          >
            Lihat Produk Kami
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white"></i>
      </div>
    </section>
  );
}